import { CircleAlert } from 'lucide-react'

/* Illustrative product mockup for the Bookkeeper page — static sample figures, not live data. */

/* Deltas are against an August of $15,364 revenue and $9,556 expenses — a $5,808 net — so all three read favorably. */
const PROFIT_AND_LOSS = [
  { label: 'Net Profit', amount: '$8,300', delta: '↑ 43%' },
  { label: 'Revenue', amount: '$16,900', delta: '↑ 10%' },
  { label: 'Expenses', amount: '$8,600', delta: '↓ 10%' },
]

const EXPENSES = [
  { label: 'Fuel', amount: '$4,494.53', share: '52%', color: '#7B1FB5' },
  { label: 'Truck & trailer expenses', amount: '$1,819.00', share: '21%', color: '#D23FC7' },
  { label: 'Business insurance', amount: '$936.00', share: '11%', color: '#0E6B7A' },
  { label: 'Parking & tolls', amount: '$750.00', share: '9%', color: '#3C8FD9' },
  { label: 'Business meals', amount: '$414.00', share: '5%', color: '#9DB51A' },
  { label: 'Uncategorized', amount: '$186.47', share: '2%', color: '#E6E5E1' },
]

const DONUT_GRADIENT =
  'conic-gradient(#7B1FB5 0 52.3%, #D23FC7 52.3% 73.4%, #0E6B7A 73.4% 84.3%, #3C8FD9 84.3% 93%, #9DB51A 93% 97.8%, #E6E5E1 97.8% 100%)'

export function BookkeeperProductVisual() {
  return (
    <div aria-hidden="true" className="bg-ink-50 rounded-sm p-5 lg:p-8">
      <div className="rounded-sm bg-white">
        <div className="flex flex-col gap-3 p-5">
          <div className="flex items-baseline justify-between gap-4">
            <span className="text-md font-semibold">Profit &amp; Loss</span>
            <span className="text-ink-600 text-[13px]">September 2026</span>
          </div>

          <div className="flex flex-col gap-2">
            {PROFIT_AND_LOSS.map((row) => (
              <div key={row.label} className="flex items-baseline justify-between gap-4">
                <span className="text-sm">{row.label}</span>
                <span className="flex items-baseline gap-2">
                  <span className="text-md font-semibold">{row.amount}</span>
                  <span className="text-[13px] text-[#2F9E5B]">{row.delta}</span>
                </span>
              </div>
            ))}
          </div>

          <div className="flex flex-col items-start gap-4 sm:flex-row">
            <div className="relative size-14 flex-none">
              <div
                className="absolute inset-0 rounded-full [mask:radial-gradient(circle,transparent_22px,#000_23px)]"
                style={{ background: DONUT_GRADIENT }}
              />
            </div>
            <div className="flex w-full min-w-0 flex-1 flex-col gap-1.5">
              {EXPENSES.map((expense) => (
                <div
                  key={expense.label}
                  className="grid grid-cols-[8px_minmax(0,1fr)_auto_28px] items-center gap-2 text-[13px]"
                >
                  <span className="size-2 rounded-[2px]" style={{ background: expense.color }} />
                  <span className="leading-tight">{expense.label}</span>
                  <span>{expense.amount}</span>
                  <span className="text-ink-600 text-right">{expense.share}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-ink-50 flex flex-col gap-2.5 border-t p-5">
          <span className="text-md font-semibold">Bookkeeping tasks</span>
          <div className="bg-surface flex items-center gap-3 rounded-sm px-3.5 py-2.5">
            <CircleAlert className="fill-warning stroke-warning-d1 size-5 flex-none" />
            <div className="flex min-w-0 flex-1 flex-col">
              <span className="text-sm font-medium text-balance">Review Ridgeway Supply purchase</span>
              <span className="text-ink-600 text-[13px]">$186.47 · Sep 14</span>
            </div>
            <div className="border-ink-100 flex-none rounded-[3px] border bg-white px-2.5 py-1 text-[13px] font-medium">
              Review
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
